const doFormSubmissionActions = (form, status) => {
	if (status === 'success') {
		form.querySelector('.js-form-fields').remove();
		form.querySelector(`.js-form-messages .${status}`).classList.remove('hidden');
	}
};

const resetFormMessages = (form) => {
	form.querySelectorAll('.js-form-messages p').forEach((msg) => msg.classList.add('hidden'));
};

export { doFormSubmissionActions, resetFormMessages };
